import React, {Component} from 'react';
import {Menu, Input, Header, Icon, Button} from 'semantic-ui-react';

class MainToolbar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            labelSearch: ' ',
            labelCreate: ' ',
            search: '',
            sending: false
        };
        this.handleAdd = this.handleAdd.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchKeyPress = this.handleSearchKeyPress.bind(this);
        this.sending = this.sending.bind(this);
    }

    componentDidMount() {
        this.setState({labelCreate: `Agregar ${this.props.name}`, labelSearch: `Buscar ${this.props.name}`})
    }

    handleAdd = () => {
        if(this.props.disable_button_add){
            this.setState({sending:true})
        }
        this.props.callbackAdd(true);
    };

    handleAdding = () => {
        this.setState({sending:false})
    }

    handleSearch = () => {
        this.props.callbackSearch(this.state.search);
    };

    handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.handleSearch();
        }
    };

    sending(){
        this.setState({sending:!this.state.sending});
    }

    handleSearchChange = (event) => {
        this.setState({search: event.target.value});
    };

    render() {
        return (
            <div>
                <Menu secondary>
                    <Menu.Item>
                        <Header as='h2'>
                            <Icon name={this.props.icon}/>
                            <Header.Content>
                                {this.props.title}
                                <Header.Subheader>{`Lista de ${this.props.title}`}</Header.Subheader>
                            </Header.Content>
                        </Header>
                    </Menu.Item>
                    <Menu.Menu position='right'>
                        <Menu.Item>
                            <Input icon={< Icon name='search' link onClick={this.handleSearch}/>}
                                   placeholder={this.state.labelSearch} value={this.state.search}
                                   onChange={this.handleSearchChange} onKeyPress={this.handleSearchKeyPress}/>
                        </Menu.Item>
                        {this.props.btnAdd
                            ? <Menu.Item>
                                <Button primary icon='add' labelPosition='left' onClick={this.handleAdd} content={this.state.labelCreate} loading={this.state.sending} disabled={this.state.sending}>

                                </Button>
                            </Menu.Item>
                            : null}
                    </Menu.Menu>
                </Menu>
            </div>
        );
    }
}

export default MainToolbar;



// WEBPACK FOOTER //
// ./src/components/extras/MainToolbar.js